var sw = window.innerWidth;
var sh = window.innerHeight;
var header = document.querySelector("header");
var sticky = 0;

// Font Resizer ------------------- Start
function fontResizer() {
  var perc = parseInt(sw) / 120;
  document.body.style.fontSize = perc + "px";
}

// Landscape Mode off ---------------- Start
const mql = window.matchMedia("(orientation:landscape)");
mql.addEventListener("change", (event) => {
  if (event.matches) {
    if (innerWidth < 930) {
      // console.log("Now in landscape orientation");
      document.getElementById("portrait-warning").style.display = "flex";
    }
  } else {
    // console.log("Now in portrait orientation");
    document.getElementById("portrait-warning").style.display = "none";
  }
});

// Loader ------------------- Start
function pageLoader() {
  setTimeout(function () {
    document.querySelector("html").classList.add("loaded");
    setTimeout(() => {
      document.querySelector(".loader-first").style.display = "none";
    }, 1000);
  }, 700);
}

// Sticky Header ---------------- Start
(function () {
  if (document.querySelector(".header")) {
    // Sticky Header Class Add and Remove ---------------- Start
    function stickyHeader() {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    }
    // Sticky Header ---------------- End

    // Window On Scroll-----------------Start
    window.addEventListener("scroll", (event) => {
      stickyHeader();
    });
  }
})();

// Window on Load ----------------- Start
window.onload = function () {
  pageLoader();
  if (sw > 1199) {
    fontResizer();
  }
};

// Window On Resize ----------------- Start
(function () {
  window.addEventListener("resize", (event) => {
    sw = window.innerWidth;
    sh = window.innerHeight;
    if (sw > 1025) {
      if (sw < 1400 && sw > 1300 && sh > 900) {
      } else {
        fontResizer();
      }
    }
  });
})();

// SVG Convert Code
window.addEventListener("load", function () {
  (function () {
    if (document.querySelector(".svg-convert")) {
      let svgs = document.querySelectorAll("img.svg-convert");
      svgs.forEach((el) => {
        const imgID = el.getAttribute("id");
        const imgClass = el.getAttribute("class");
        const imgURL = el.getAttribute("src");

        fetch(imgURL)
          .then((response) => response.text())
          .then((data) => {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(data, "text/html");
            let svg = xmlDoc.querySelector("svg");
            if (typeof imgID !== "undefined") {
              svg.setAttribute("id", imgID);
            }

            if (typeof imgClass !== "undefined") {
              svg.setAttribute("class", imgClass + " svg-converted");
            }

            svg.removeAttribute("xmlns:a");

            el.parentNode.replaceChild(svg, el);
          });
      });
    }
  })();
});

//  Search Modal
(function () {
  if (document.querySelector(".search-modal")) {
    // Get references to the search button and close button elements
    const searchBtn = document.getElementById("searchbtn");
    const searchCloseBtn = document.getElementById("searchclosebtn");

    // Get references to the body and search elements
    const html = document.querySelector("html");
    const body = document.querySelector("body");
    const search = document.getElementById("search");

    // Add an event listener to the search button that adds the "search-modal-open" class to the body and the "open-box" class to the search element
    searchBtn.addEventListener("click", function () {
      html.classList.add("requires-no-scroll");
      body.classList.add("search-modal-open");
      search.classList.add("open-box");
    });

    // Add an event listener to the close button that removes the "search-modal-open" class from the body and the "open-box" class from the search element
    searchCloseBtn.addEventListener("click", function () {
      html.classList.remove("requires-no-scroll");
      body.classList.remove("search-modal-open");
      search.classList.remove("open-box");
    });
  }
})();

// Language Dropdown Active-------------------Start

if ("ontouchstart" in document.documentElement) {
  // document.querySelector(".megamenu").classList.add("touchDevice");
  var selectedItem = document.getElementsByClassName("langWrapper");
  var k;
  for (k = 0; k < selectedItem.length; k++) {
    selectedItem[k].addEventListener("click", function () {
      this.classList.toggle("open");
    });
  }
} else {
  var selectedItem = document.getElementsByClassName("langWrapper");
  var k;
  for (k = 0; k < selectedItem.length; k++) {
    selectedItem[k].addEventListener("mouseenter", function () {
      this.classList.add("open");
    });
    selectedItem[k].addEventListener("mouseleave", function () {
      this.classList.remove("open");
    });
  }
}

// Navigation slide Active on a Desktop ---------------- Start
(function () {
  if (document.querySelector("#toggle")) {
    let toggleMenu = document.querySelector("#toggle");
    let navigation = document.querySelector(".navigation-wrapper");
    // let htmlEl = document.querySelector("html");

    toggleMenu.addEventListener("click", (event) => {
      // console.log('this', event)
      let _this = event.target;
      _this.classList.toggle("active");
      document.querySelector(".navigation").classList.toggle("open");
      // htmlEl.classList.toggle("overflow-hidden");
      navigation.classList.toggle("opened");
    });
  }
})();

// navigation accordion ---------------- Start
(function () {
  if (document.querySelector(".navigation")) {
    let dropdown = document.querySelectorAll(".dropdown");
    dropdown.forEach(function (dp) {
      let dropdownItem = dp.closest(".menu__menuitem");
      dropdownItem.classList.add("dropdown-active");
    });

    let accordionNav = document.querySelectorAll(
      ".menu__menuitem.dropdown-active"
    );
    let iterator;

    for (iterator = 0; iterator < accordionNav.length; iterator++) {
      accordionNav[iterator]
        .querySelector(".menu__menuitem__icon")
        .addEventListener("click", function (e) {
          e.stopPropagation();
          let currentItem = e.target;

          // console.log(currentItem)
          let panel = this.nextElementSibling;
          if (currentItem.classList.contains("open")) {
            currentItem.classList.remove("open");
            panel.style.maxHeight = "0px";
          } else {
            let mainItem = currentItem
              .closest(".menu")
              .querySelectorAll(".menu__menuitem__icon");
            mainItem.forEach(function (itm) {
              itm.classList.remove("open");
              itm.nextElementSibling.style.maxHeight = "0px";
            });
            currentItem.classList.add("open");
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
    }
  }
})();

// animate Observer------------Start
(function () {
  if (window.innerWidth > 767) {
    let anim = [...document.querySelectorAll(".animate")];

    let options = {
      rootMargin: "0px",
      threshold: 0.2,
    };

    let animate = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.style.animation = `anim 1s ${entry.target.dataset.delay} forwards ease-out`;
        }
      });
    };

    let observer = new IntersectionObserver(animate, options);

    anim.forEach((item, idx) => {
      observer.observe(item);
    });
  }
})();

// Lazy Load Img observer
(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const imgElements = document.querySelectorAll("img[data-src]");

    const lazyLoadingImage = (entries, observer2) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.src = entry.target.dataset.src;
        entry.target.addEventListener("load", () => {
          entry.target.classList.remove("lazy-img");
          observer2.unobserve(entry.target);
        });
      });
    };
    const lazyLoadingObserver = new IntersectionObserver(lazyLoadingImage, {
      threshold: 0,
      rootMargin: "0px 0px 150px 0px",
    });
    imgElements.forEach((img) => lazyLoadingObserver.observe(img));
  });
})();

// clip path observer
(function () {
  if (window.innerWidth > 767) {
    let imageObserver = [...document.querySelectorAll(".img__observer")];
    let option = {
      rootMargin: "-200px",
      threshold: 0.2,
    };

    let setItemActive = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("active");
        }
      });
    };

    let observer2 = new IntersectionObserver(setItemActive, option);

    imageObserver.forEach((item1, idx) => {
      observer2.observe(item1);
    });
  }
})();

// custom select to
function customSelect(updateOnly = false) {
  (function () {
    var x, i, j, l, ll, selElmnt, a, b, c;
    x = document.getElementsByClassName("custom-select");
    l = x.length;

    for (i = 0; i < l; i++) {
      selElmnt = x[i].getElementsByTagName("select")[0];
      ll = selElmnt.length;

      if (!updateOnly) {
        // If updateOnly is false, create the structure
        a = x[i].querySelector(".select-selected");
        b = x[i].querySelector(".select-items");

        if (!a) {
          a = document.createElement("DIV");
          a.setAttribute("class", "select-selected");
          x[i].appendChild(a);
        }

        if (!b) {
          b = document.createElement("DIV");
          b.setAttribute("class", "select-items select-hide");
          x[i].appendChild(b);
        }

        a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
      } else {
        // If updateOnly is true, just update existing elements
        a = x[i].querySelector(".select-selected");
        b = x[i].querySelector(".select-items");

        if (!a || !b) {
          console.error("Custom select structure not found. Ensure customSelect() was called without updateOnly first.");
          return;
        }

        // Clear previous options
        b.innerHTML = "";
      }

      // Populate options
      for (j = 1; j < ll; j++) {
        c = document.createElement("DIV");
        c.innerHTML = selElmnt.options[j].innerHTML;

        c.addEventListener("click", function (e) {
          var y, i, k, s, h, sl, yl;
          s = this.parentNode.parentNode.getElementsByTagName("select")[0];
          sl = s.length;
          h = this.parentNode.previousSibling;
          for (i = 0; i < sl; i++) {
            if (s.options[i].innerHTML == this.innerHTML) {
              s.selectedIndex = i;
              h.innerHTML = this.innerHTML;
              y = this.parentNode.getElementsByClassName("same-as-selected");
              yl = y.length;
              for (k = 0; k < yl; k++) {
                y[k].removeAttribute("class");
              }
              this.setAttribute("class", "same-as-selected");
              break;
            }
          }
          h.click();
        });

        b.appendChild(c);
      }

      if (!updateOnly) {
        a.addEventListener("click", function (e) {
          let heroformDropdown = document.querySelectorAll(
            ".hero-form__col:not(.hero-form__col--btnn) .hero-form__dropdown"
          );
          heroformDropdown.forEach(function (elmt) {
            elmt.classList.remove("active");
          });

          e.stopPropagation();
          closeAllSelect(this);
          this.nextSibling.classList.toggle("select-hide");
          this.classList.toggle("select-arrow-active");
        });
      }
    }

    function closeAllSelect(elmnt) {
      var x, y, i, xl, yl, arrNo = [];
      x = document.getElementsByClassName("select-items");
      y = document.getElementsByClassName("select-selected");
      xl = x.length;
      yl = y.length;
      for (i = 0; i < yl; i++) {
        if (elmnt == y[i]) {
          arrNo.push(i);
        } else {
          y[i].classList.remove("select-arrow-active");
        }
      }
      for (i = 0; i < xl; i++) {
        if (arrNo.indexOf(i)) {
          x[i].classList.add("select-hide");
        }
      }
    }

    document.addEventListener("click", closeAllSelect);
  })();
}



customSelect()





// event news slider
if (document.querySelector(".our-team__slider")) {
  let newseEventslider = new Swiper(".our-team__slider .swiper", {
    slidesPerView: "auto",
    observeParents: true,
    observer: true,
    autoHeight: true,
    navigation: {
      nextEl: ".our-team__slider .swiper-button-next",
      prevEl: ".our-team__slider .swiper-button-prev",
    },
  });
}

// Properties Detail Page - Gallery Slider
if (document.querySelector(".gallerySlider")) {
  let propertyGallerySliderRight = new Swiper(".gallerySlider__right .swiper", {
    loop: false,
    direction: "horizontal",
    slidesPerView: "auto",
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    speed: 1500,
    observeParents: true,
    observer: true,
    breakpoints: {
      992: {
        direction: "vertical",
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        direction: "vertical",
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });

  let interleaveOffset = 0.5;

  let propertyGallerySliderLeft = new Swiper(".gallerySlider__left .swiper", {
    loop: false,
    speed: 1500,
    watchSlidesProgress: true,
    observeParents: true,
    observer: true,
    thumbs: {
      swiper: propertyGallerySliderRight,
    },
    navigation: {
      nextEl: ".generic-slider-controls .swiper-button-next",
      prevEl: ".generic-slider-controls .swiper-button-prev",
    },
    on: {
      progress: function () {
        var swiper = this;
        for (var i = 0; i < swiper.slides.length; i++) {
          var slideProgress = swiper.slides[i].progress,
            innerOffset = swiper.width * interleaveOffset,
            innerTranslate = slideProgress * innerOffset;
          swiper.slides[i].querySelector(".img-wrapper").style.transform =
            "translateX(" + innerTranslate + "px)";
        }
      },
      touchStart: function () {
        var swiper = this;
        for (var i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = "";
        }
      },
      setTransition: function (swiper, speed) {
        for (var i = 0; i < swiper.slides.length; i++) {
          swiper.slides[i].style.transition = speed + "ms";
          swiper.slides[i].querySelector(".img-wrapper").style.transition =
            speed + "ms";
        }
      },
    },
  });

  Fancybox.bind("[data-gallery]", {
    // Your custom options
  });
}

// Quantity Add and Subtract
// window.addEventListener("load", () => {
//   const qtyInputs = document.querySelectorAll(".qty-input");

//   qtyInputs.forEach((qtyInput) => {
//     const input = qtyInput.querySelector(".product-qty");
//     const minusBtn = qtyInput.querySelector(".qty-count--minus");
//     const addBtn = qtyInput.querySelector(".qty-count--add");
//     const qtyMin = parseInt(input.min, 10);
//     const qtyMax = parseInt(input.max, 10);

//     const updateButtons = (qty) => {
//       minusBtn.disabled = qty <= qtyMin;
//       addBtn.disabled = qty >= qtyMax;
//     };

//     const validateAndSetQty = () => {
//       let qty = parseInt(input.value, 10);
//       qty = isNaN(qty) ? qtyMin : Math.max(qtyMin, Math.min(qty, qtyMax));
//       input.value = qty;
//       updateButtons(qty);
//     };

//     input.addEventListener("change", validateAndSetQty);

//     [minusBtn, addBtn].forEach((btn) => {
//       btn.addEventListener("click", () => {
//         let qty = parseInt(input.value, 10);
//         qty += btn.dataset.action === "add" ? 1 : -1;
//         input.value = qty = Math.max(qtyMin, Math.min(qty, qtyMax));
//         updateButtons(qty);
//       });
//     });
//   });
// });



// My account - Password
if (document.getElementById("showPassword")) {
  var showPassword = document.getElementById("showPassword");
  const password = showPassword.previousElementSibling;

  showPassword.addEventListener("click", function () {
    // toggle the type attribute
    const type =
      password.getAttribute("type") === "password" ? "text" : "password";
    password.setAttribute("type", type);
    // toggle the eye icon
    this.classList.toggle("hovered");
  });
}

// Drag and Drop Files
// (function () {
//   if (document.querySelector(".inputFileField")) {
//     function initializeFileField(element) {
//       const input = element.querySelector("input");
//       const label = element.querySelector("label");
//       const fieldDropMessage = element.querySelector(".icon");
//       const fileListContainer = element.querySelector(".file-list");
//       input.addEventListener("change", handleFileSelect);
//       label.addEventListener("dragover", handleDragOver);
//       label.addEventListener("dragleave", handleDragLeave);
//       label.addEventListener("drop", handleFileDrop);
//       function handleFileSelect() {
//         displayFileList();
//       }
//       function handleDragOver(e) {
//         e.preventDefault();
//         label.classList.add("drag-over");
//       }
//       function handleDragLeave(e) {
//         e.preventDefault();
//         label.classList.remove("drag-over");
//       }
//       function handleFileDrop(e) {
//         e.preventDefault();
//         label.classList.remove("drag-over");
//         const files = e.dataTransfer.files;
//         const fileList = new DataTransfer();
//         Array.from(files).forEach(file => {
//           fileList.items.add(file);
//         });
//         input.files = fileList.files;
//         displayFileList();
//       }
//       function displayFileList() {
//         fileListContainer.innerHTML = "";
//         if (input.files.length > 1) {
//           console.warn("More than one file selected. Only one file is allowed.");
//           return;
//         }
//         Array.from(input.files).forEach(file => {
//           const listItem = document.createElement("div");
//           listItem.className = "file-item";
//           listItem.innerHTML = `<span>${file.name}</span><button class="remove-file"></button>`;
//           fileListContainer.appendChild(listItem);
//           if (document.querySelector(".inputFileField--icon") && fieldDropMessage) {
//             fieldDropMessage.style.display = "none";
//           }
//           const removeBtn = listItem.querySelector(".remove-file");
//           removeBtn.addEventListener("click", e => {
//             e.preventDefault();
//             removeFile(file);
//           });
//         });
//       }
//       function removeFile(file) {
//         const newFiles = Array.from(input.files).filter(f => f !== file);
//         const newFileList = new DataTransfer();
//         newFiles.forEach(newFile => {
//           newFileList.items.add(newFile);
//         });
//         input.files = newFileList.files;
//         displayFileList();
//         if (document.querySelector(".inputFileField--icon") && fieldDropMessage && input.files.length === 0) {
//           fieldDropMessage.style.display = "block";
//         }
//       }
//     }

//     // Initialize for each component with the specified class
//     const inputFileFields = document.querySelectorAll(".inputFileField--icon, .inputFileField:not(.inputFileField--icon)");
//     inputFileFields.forEach(element => {
//       initializeFileField(element);
//     });
//   }
// })();

// (function () {
//   if (document.querySelector(".inputFileField")) {
//     function initializeFileField(element) {
//       const input = element.querySelector("input");
//       const label = element.querySelector("label");
//       const fieldDropMessage = element.querySelector(".icon");
//       const fileListContainer = element.querySelector(".file-list");
//       input.addEventListener("change", handleFileSelect);
//       label.addEventListener("dragover", handleDragOver);
//       label.addEventListener("dragleave", handleDragLeave);
//       label.addEventListener("drop", handleFileDrop);

//       // Adding the default file on DOM load
//       const defaultFileName = "Adib-Forms-Image.png"; // Specify your default file name here
//       displayDefaultFile(defaultFileName);

//       function handleFileSelect() {
//         displayFileList();
//       }

//       function handleDragOver(e) {
//         e.preventDefault();
//         label.classList.add("drag-over");
//       }

//       function handleDragLeave(e) {
//         e.preventDefault();
//         label.classList.remove("drag-over");
//       }

//       function handleFileDrop(e) {
//         e.preventDefault();
//         label.classList.remove("drag-over");
//         const files = e.dataTransfer.files;
//         const fileList = new DataTransfer();
//         Array.from(files).forEach(file => {
//           fileList.items.add(file);
//         });
//         input.files = fileList.files;
//         displayFileList();
//       }

//       function displayFileList() {
//         fileListContainer.innerHTML = "";
//         if (input.files.length > 1) {
//           console.warn("More than one file selected. Only one file is allowed.");
//           return;
//         }
//         Array.from(input.files).forEach(file => {
//           const listItem = document.createElement("div");
//           listItem.className = "file-item";
//           listItem.innerHTML = `<span>${file.name}</span><button class="remove-file"></button>`;
//           fileListContainer.appendChild(listItem);
//           if (document.querySelector(".inputFileField--icon") && fieldDropMessage) {
//             fieldDropMessage.style.display = "none";
//           }
//           const removeBtn = listItem.querySelector(".remove-file");
//           removeBtn.addEventListener("click", e => {
//             e.preventDefault();
//             removeFile(file);
//           });
//         });
//       }

//       function removeFile(file) {
//         const newFiles = Array.from(input.files).filter(f => f !== file);
//         const newFileList = new DataTransfer();
//         newFiles.forEach(newFile => {
//           newFileList.items.add(newFile);
//         });
//         input.files = newFileList.files;
//         displayFileList();
//         if (document.querySelector(".inputFileField--icon") && fieldDropMessage && input.files.length === 0) {
//           fieldDropMessage.style.display = "block";
//         }
//       }

//       function displayDefaultFile(fileName) {
//         // Creating a mock File object
//         const defaultFile = new File([], fileName);
//         const fileList = new DataTransfer();
//         fileList.items.add(defaultFile);
//         input.files = fileList.files;

//         // Call displayFileList to show the default file
//         displayFileList();
//       }
//     }

//     // Initialize for each component with the specified class
//     const inputFileFields = document.querySelectorAll(".inputFileField--icon, .inputFileField:not(.inputFileField--icon)");
//     inputFileFields.forEach(element => {
//       initializeFileField(element);
//     });
//   }
// })();

(function () {
  if (document.querySelector(".inputFileField")) {
    function initializeFileField(element) {
      const input = element.querySelector("input[type='file']");
      const label = element.querySelector("label");
      const fileListContainer = element.querySelector(".file-list");

      input.addEventListener("change", handleFileSelect);
      label.addEventListener("dragover", handleDragOver);
      label.addEventListener("dragleave", handleDragLeave);
      label.addEventListener("drop", handleFileDrop);

      // Handle existing file items in the HTML
      const existingFileItem = fileListContainer.querySelector(".file-item");
      if (existingFileItem) {
        const fileName = existingFileItem.querySelector("span").textContent;
        attachRemoveEvent(existingFileItem, fileName);
      }

      function handleFileSelect() {
        displayFileList();
      }

      function handleDragOver(e) {
        e.preventDefault();
        label.classList.add("drag-over");
      }

      function handleDragLeave(e) {
        e.preventDefault();
        label.classList.remove("drag-over");
      }

      function handleFileDrop(e) {
        e.preventDefault();
        label.classList.remove("drag-over");
        const files = e.dataTransfer.files;
        const fileList = new DataTransfer();
        Array.from(files).forEach((file) => {
          fileList.items.add(file);
        });
        input.files = fileList.files;
        displayFileList();
      }

      function displayFileList() {
        fileListContainer.innerHTML = "";
        Array.from(input.files).forEach((file) => {
          const listItem = document.createElement("div");
          listItem.className = "file-item";
          listItem.innerHTML = `<span>${file.name}</span><button class="remove-file"></button>`;
          fileListContainer.appendChild(listItem);
          attachRemoveEvent(listItem, file.name);
        });
      }

      function removeFile(fileName) {
        const newFiles = Array.from(input.files).filter(
          (f) => f.name !== fileName
        );
        const newFileList = new DataTransfer();
        newFiles.forEach((newFile) => {
          newFileList.items.add(newFile);
        });
        input.files = newFileList.files;
        displayFileList();
      }

      function attachRemoveEvent(listItem, fileName) {
        const removeBtn = listItem.querySelector(".remove-file");
        removeBtn.addEventListener("click", (e) => {
          e.preventDefault();
          removeFile(fileName);
          listItem.remove();
        });
      }
    }

    // Initialize for each component with the specified class
    const inputFileFields = document.querySelectorAll(".inputFileField");
    inputFileFields.forEach((element) => {
      initializeFileField(element);
    });
  }
})();

// Popup - Start
Modal(
  ".modal--uploadReceipt",
  ".modal-backdrop--uploadReceipt",
  "#uploadReceipt"
);
Modal(".modal--saleNow", ".modal-backdrop--saleNow", "#saleNow");
Modal(".modal--membership", ".modal-backdrop--membership", "#membership");
Modal(".modal--emailSent", ".modal-backdrop--emailSent", "#emailSent");

// custom modal
function Modal(modalMainWrapper, backdrop, show) {
  if (document.querySelector(modalMainWrapper)) {
    const modal = document.querySelector(modalMainWrapper);
    const modalBackdrop = document.querySelector(backdrop);
    const showModals = document.querySelectorAll(show);
    const rootEl = document.querySelector("html");

    function closeAllModals() {
      document.querySelectorAll(".modal.show").forEach((openModal) => {
        openModal.classList.remove("show");
      });
      document
        .querySelectorAll(".modal-backdrop.show")
        .forEach((openBackdrop) => {
          openBackdrop.classList.remove("show");
        });
    }

    function showModal() {
      modal.classList.add("show");
      modalBackdrop.classList.add("show");
      rootEl.classList.add("overflow-hidden");
    }

    function hideModal() {
      modal.classList.remove("show");
      modalBackdrop.classList.remove("show");
      rootEl.classList.remove("overflow-hidden");
    }

    showModals.forEach((showModalTrigger) => {
      showModalTrigger.addEventListener("click", function (e) {
        closeAllModals();
        showModal();
      });
    });

    document.addEventListener("click", function (e) {
      const modal = e.target.closest(".modal");

      if (
        e.target.classList.contains("modal__cancel") ||
        e.target.classList.contains("modal-backdrop")
      ) {
        if (modal) {
          hideModal();
        } else {
          hideModal();
        }
      }
    });
  }
}
// Popup - End

// Tab Switch Content
// switchContent Tabs-- Start
if (document.querySelector(".switchContent__tabs1")) {
  window.addEventListener("load", function () {
    // store tabs variable
    var myTabs = document.querySelectorAll(
      ".switchContent__tabs1 .switchContent__tabBtn"
    );
    function myTabClicks(tabClickEvent) {
      for (var i = 0; i < myTabs.length; i++) {
        myTabs[i].classList.remove("active");
      }
      var clickedTab = tabClickEvent.currentTarget;
      clickedTab.classList.add("active");
      tabClickEvent.preventDefault();
      var myContentPanes = document.querySelectorAll(
        ".switchContent__tabContentWrapper1 .switchContent__tabContent"
      );
      for (i = 0; i < myContentPanes.length; i++) {
        myContentPanes[i].classList.remove("active");
      }
      var anchorReference = tabClickEvent.target;
      var activePaneId = anchorReference.getAttribute("data-attr");
      var activePane = document.querySelector(activePaneId);
      activePane.classList.add("active");
    }
    for (i = 0; i < myTabs.length; i++) {
      myTabs[i].addEventListener("click", myTabClicks);
    }
  });
}
if (document.querySelector(".switchContent__tabs2")) {
  window.addEventListener("load", function () {
    // store tabs variable
    var myTabs = document.querySelectorAll(
      ".switchContent__tabs2 .switchContent__tabBtn"
    );
    function myTabClicks(tabClickEvent) {
      for (var i = 0; i < myTabs.length; i++) {
        myTabs[i].classList.remove("active");
      }
      var clickedTab = tabClickEvent.currentTarget;
      clickedTab.classList.add("active");
      tabClickEvent.preventDefault();
      var myContentPanes = document.querySelectorAll(
        ".switchContent__tabContentWrapper2 .switchContent__tabContent"
      );
      for (i = 0; i < myContentPanes.length; i++) {
        myContentPanes[i].classList.remove("active");
      }
      var anchorReference = tabClickEvent.target;
      var activePaneId = anchorReference.getAttribute("data-attr");
      var activePane = document.querySelector(activePaneId);
      activePane.classList.add("active");
    }
    for (i = 0; i < myTabs.length; i++) {
      myTabs[i].addEventListener("click", myTabClicks);
    }
  });
}
// switchContent Tabs -- End
